var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPublishModalClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33.2571,
    height: 34,
    rx: 4,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5289 23.4965C11.3939 23.4549 11.2854 23.3273 11.2352 23.124C11.1349 22.7173 11.3068 22.1602 11.6188 21.8803L23.042 11.6322C23.354 11.3523 23.6878 11.4552 23.7882 11.8623C23.8884 12.269 23.7166 12.8261 23.4046 13.106L11.9814 23.3541C11.8252 23.4942 11.6639 23.5382 11.5289 23.4965Z",
    fill: "#424242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0801 23.8814C22.9426 23.9139 22.7844 23.859 22.638 23.7091L11.9218 12.7239C11.6292 12.4242 11.4949 11.8569 11.6219 11.4575C11.7489 11.058 12.0888 10.9775 12.3817 11.2775L23.0979 22.2627C23.3905 22.5624 23.5249 23.1297 23.3979 23.5292C23.3343 23.7291 23.2175 23.8488 23.0801 23.8814Z",
    fill: "#424242"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublishModalClose);
export default __webpack_public_path__ + "static/media/PublishModalClose.cdfc759389f260eee3209a9622ea7780.svg";
export { ForwardRef as ReactComponent };